<template>
  <div>
    <portal to="authTitle">
      <h2
        class="mt-6 text-xl leading-tight text-center sm:text-2xl md:text-3xl"
        id="formlabel"
      >
        Sign in
      </h2>
    </portal>
    <form
      class="password-set-form grid grid-cols-1 gap-4 sm:gap-6"
      role="form"
      aria-labelledby="formlabel"
    >
      <div
        class="errors my-2 p-2 text-center bg-red-100 text-red-900"
        v-if="incorrect"
      >
        This email and password combination was not found
      </div>
      <div
        class="success my-2 p-2 text-center bg-green-100 text-green-900"
        v-if="success"
      >
        Successfully Logged In
      </div>
      <label class="block text-sm">
        <span class="font-semibold text-gray-600 flex justify-between mb-2"
          >Email</span
        >
        <input
          class="form-input min-h-10 block w-full"
          v-model="submission.data.email"
          type="email"
          placeholder="ex: my.name@gmail.com"
          required
          minlength="4"
          maxlength="100"
          @keyup.enter="login"
        />
      </label>
      <label class="block text-sm">
        <span class="font-semibold text-gray-600 flex justify-between mb-2"
          >Password</span
        >
        <div class="relative">
          <input
            class="form-input min-h-10 block w-full pr-8"
            v-model="submission.data.password"
            :type="passwordInputType"
            placeholder="Password"
            required
            minlength="8"
            maxlength="128"
            @keyup.enter="login"
          />
          <a
            class="absolute inset-y-0 right-0 flex items-center px-4 underline focus:outline-none"
            @click="changeInputType"
          >
            <span v-if="passwordInputType === 'password'">Show</span>
            <span v-if="passwordInputType === 'text'">Hide</span>
          </a>
        </div>
      </label>
      <div class="mt-6">
        <button
          class="block w-full text-center rounded font-semibold border-2 border-transparent px-4 min-h-10 bg-yellow-500 text-gray-700 hover:bg-yellow-900 focus:bg-yellow-900"
          @click="login"
          type="button"
        >
          Sign in
        </button>
      </div>
      <div class="text-sm text-center text-gray-600">
        <p>
          <span class="block"
            >Already have an account but haven't
            <router-link
              class="text-teal-900 font-semibold"
              :to="'/set-password'"
              >set a password?</router-link
            >
          </span>
        </p>
        <router-link
          class="text-teal-900 font-semibold"
          :to="'/forgot-password'"
        >
          Forgot your Password?
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      incorrect: false,
      success: false,
      submission: {
        data: {
          email: "",
          password: ""
        }
      },
      passwordInputType: "password"
    };
  },
  methods: {
    async login() {
      this.resetResponses();
      let response = await fetch(
        process.env.VUE_APP_FORMIO_URL + "/advisor/login",
        {
          headers: {
            "Content-Type": "application/json"
          },
          method: "post",
          body: JSON.stringify(this.submission)
        }
      );

      let status = await response.status;
      if (status !== 200) {
        this.success = false;
        this.incorrect = true;
        return false;
      }

      this.incorrect = false;
      let user = await response.json();
      let token = response.headers.get("x-jwt-token");
      this.$store.commit("login", {
        user: user,
        token: token
      });

      /* Get University */
      await this.getUniversity(user.data.university.value);

      /* Existing user data storage  */
      this.$store.commit("setUserDetails", {
        email: user.data.email,
        name: user.data.firstname + " " + user.data.lastname,
        university: user.data.university.label,
        universityId: user.data.university.value,
        loggedIn: true,
        dynamicUniversity: user.data.dynamicUniversity
      });
      this.success = true;
      this.$router.push("/my-students");
    },
    async getUniversity(ope8_id) {
      let response = await fetch(
        process.env.VUE_APP_ENROLLMENT_URL + "/api/university/" + ope8_id,
        {
          headers: {
            Accept: "application/json"
          }
        }
      );

      let status = await response.status;
      let university = null;
      if (status == 200) {
        university = await response.json();
      }

      this.$store.commit("setUniversity", university);
    },
    resetResponses() {
      this.incorrect = false;
      this.success = false;
    },
    changeInputType() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    }
  }
};
</script>
